import React, { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useMultipartUpload from '../../../modules/common/useMultipartUpload';
import { Lesson } from '../../../modules/lesson/types';
import useDeleteUnit from '../../../modules/unit/useDeleteUnit';
import useUpdateUnit from '../../../modules/unit/useUpdateUnit';
import { CourseDetailsContext } from '../../layout/CourseEditLayout/context';
import { ConfirmationContext } from '../../organisms/ConfirmationModal/context';
import { ErrorContext } from '../../organisms/ModalError/context';
import { ResourceEditBlockProps } from './ResourceEditBlock';
import { ResourceEditBlockPresenterProps } from './ResourceEditBlock.presenter';

const withInteractor = (
  Presenter: React.FC<ResourceEditBlockPresenterProps>,
): React.FC<ResourceEditBlockProps> => {
  const Interactor: React.FC<ResourceEditBlockProps> = (props) => {
    const { setError } = useContext(ErrorContext);
    const { setConfirmation } = useContext(ConfirmationContext);
    const { courseState } = useContext(CourseDetailsContext);

    const { lessonId, unitId } = useParams<{ lessonId: string; unitId: string }>();
    const [updateUnitState, updateUnit] = useUpdateUnit(Number(unitId));
    const [
      { loading: uploadFileLoading, error: uploadFileError }, uploadFile,
    ] = useMultipartUpload('files');

    const lesson: Lesson | null = useMemo(() => courseState.data?.lessons.find((item) => {
      return `${item.id}` === lessonId;
    }) || null, [courseState.data, lessonId]);

    const [
      { loading: deleteLoading, error: deleteError }, deleteUnit,
    ] = useDeleteUnit();

    return (
      <Presenter
        {...props}
        data={lesson}
        loading={courseState.loading || updateUnitState.loading || deleteLoading || uploadFileLoading}
        error={courseState.error || updateUnitState.error || deleteError || uploadFileError}
        setError={setError}
        setConfirmation={setConfirmation}
        updateUnit={updateUnit}
        deleteUnit={deleteUnit}
        uploadFile={uploadFile}
        refetchCourse={courseState.refetch}
      />
    );
  };

  return Interactor;
};

export default withInteractor;
